import React from 'react';
import useTheme from 'branding/theme';
import useComponentMargin from '../../hooks/useComponentMargin';
import PlusCircle from '../../graphics/PlusCircle';
import StatusCircle from '../../graphics/StatusCircle';
const CheckboxCircle = ({ isChecked, isHovered, isFocused, styles, disabled }) => {
    const { inputs: { choiceStyles } } = useTheme();
    const marginStyles = useComponentMargin({ marginVertical: 'small', marginRight: 'small' });
    const mergedStyles = {
        ...marginStyles,
        ...(isFocused && !isHovered && choiceStyles.focused),
        ...styles
    };
    return isChecked ? (React.createElement(StatusCircle, { status: "success", size: "tiny", styles: mergedStyles, disabled: disabled })) : (React.createElement(PlusCircle, { size: "tiny", styles: mergedStyles, disabled: disabled }));
};
export default CheckboxCircle;
//# sourceMappingURL=index.js.map